import { render, staticRenderFns } from "./NothingFoundCmp.vue?vue&type=template&id=395710f2&scoped=true&"
import script from "./NothingFoundCmp.vue?vue&type=script&lang=js&"
export * from "./NothingFoundCmp.vue?vue&type=script&lang=js&"
import style0 from "./NothingFoundCmp.vue?vue&type=style&index=0&id=395710f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395710f2",
  null
  
)

export default component.exports